import XdslLineIntentionPopin from "../../../../common/broadband/components/XdslLineIntentionPopin.vue";
import CartRecovery from "./components/CartRecovery.vue";
import NewInternetOfferTile from "./components/NewInternetOfferTile.vue";
import OffersTabs from "./components/OffersTabs.vue";
import DiscountedInternetOfferTile from "./components/DiscountedInternetOfferTile.vue";
import InternetOfferDetails from "./components/InternetOfferDetails.vue";
import {alignDivHeights, alignDivsHeightsByLine} from "../../utils/AlignDivHeightsUtil";
import GenericButtonCta from "../../../../common/broadband/components/GenericButtonCta.vue";
import OffersAnimationSection from "../../../../common/components/vue/animation/OffersAnimationSection.vue";
import Banner from "../../../../fmfmo/common/components/Banner.vue";

const listOfDivToAlign = [
    "tag-timer", "title-align", "debit",
    "internet-secondary", "cross-discount-banner",
    "price-align", "offer-edito-content", "mobileprice-odrmention-align", "detail-link-align"
];
const listOfCollapsibleDivToAlign = [
    "media-body-description-0", "media-body-description-1",
    "media-body-description-2", "media-body-description-3", "media-body-description-4", "media-body-description-5"
];

const root = document.getElementById("internet-offers-main");
const dto = JSON.parse(root.dataset.dto)

window.app = new Vue({
    el: root,
    name: "InternetOffersMain",
    components: {
        XdslLineIntentionPopin,
        CartRecovery,
        DiscountedInternetOfferTile,
        NewInternetOfferTile,
        OffersTabs,
        GenericButtonCta,
        OffersAnimationSection,
        InternetOfferDetails,
        Banner
    },
    data() {
        return {
            dto: dto,
            selectedInternetOffersTiles: null,
            displayedInternetOffersTiles: [],
            displayedOffersAnimation: null,
            displayedInternetOffersAnimationsTiles: null,
            displayedInternetMobileAtHomeOffersTiles: null,
            displayedAlternativeOffersTiles: null,
            showTabs: dto.tabs != null,
            showAttributes: false,
            showMobileClientOffers: false,
            offersType: dto.offersType,
            toggleAttributesBtnLabel: dto.showAttributesBtnLabel,
            toggleAttributesBtnTms: dto.showAttributesBtnTms,
            showAttributesBtnTms: dto.showAttributesBtnTms,
            hideAttributesBtnTms: dto.hideAttributesBtnTms,
            showAttributesBtnLabel: dto.showAttributesBtnLabel,
            hideAttributesBtnLabel: dto.hideAttributesBtnLabel,
            showDetailPage: dto.showOfferDetailPage,
            showDetailPageBtnLabel: dto.showOfferDetailPageBtnLabel,
            offersOffset: 0,
        }
    },
    computed: {
        internetOffersTiles() {
            if (this.dto && this.dto.offers) {
                return this.dto.offers;
            } else {
                return [];
            }
        },
        internetBasicsOffersTiles() {
            if (this.dto && this.dto.basicOffers) {
                return this.dto.basicOffers;
            } else {
                return [];
            }
        },
        internetSmartTVOffersTiles() {
            if (this.dto && this.dto.smartTVOffers) {
                return this.dto.smartTVOffers;
            } else {
                return [];
            }
        },
        internetOffersTilesForMobileClients() {
            if (this.dto && this.dto.defaultOffersForMobileClient) {
                return this.dto.defaultOffersForMobileClient;
            } else {
                return [];
            }
        },
        selectedInternetOfferSeoId() {
            if ((this.internetOffersTiles) && ((this.internetOffersTiles.length > 0))) {
                return this.internetOffersTiles[0].seoId;
            } else {
                return undefined;
            }
        },
        offersAnimation() {
            if (this.dto && this.dto.offersAnimation) {
                return this.dto.offersAnimation;
            } else {
                return null;
            }
        },
        leftTabOffersAnimation() {
            if (this.dto && this.dto.leftTabOffersAnimation) {
                return this.dto.leftTabOffersAnimation;
            } else {
                return null;
            }
        },
        rightTabOffersAnimation() {
            if (this.dto && this.dto.rightTabOffersAnimation) {
                return this.dto.rightTabOffersAnimation;
            } else {
                return null;
            }
        },
        internetMobileAtHomeOffersTiles() {
            if (this.dto && this.dto.mobileAtHomeOffers) {
                return this.dto.mobileAtHomeOffers;
            } else {
                return [];
            }
        },
        alternativeOffersTiles() {
            if (this.dto && this.dto.alternativeOffers) {
                return this.dto.alternativeOffers;
            } else {
                return [];
            }
        },
        showMoreOrLessOffersButton() {
            return this.selectedInternetOffersTiles !== null
            && this.selectedInternetOffersTiles.length > 3
            && this.displayedInternetOffersTiles !== null
        },
        showMoreOffersButton() {
            return this.showMoreOrLessOffersButton
                && this.displayedInternetOffersTiles.length < this.selectedInternetOffersTiles.length;
        },
        showLessOffersButton() {
            return this.showMoreOrLessOffersButton
                && this.displayedInternetOffersTiles.length >= this.selectedInternetOffersTiles.length;
        },
        showDiscountedInternetOfferTile() {
            return this.dto.offersAttributes != null && !this.showMoreOffersButton;
        },
        hasAlternativeOffers() {
            return this.displayedAlternativeOffersTiles && this.displayedAlternativeOffersTiles.length > 0;
        },
        hasInternetMobileAtHomeOffers() {
            return this.displayedInternetMobileAtHomeOffersTiles && this.displayedInternetMobileAtHomeOffersTiles.length > 0;
        },
        showDiscountedOfferTileWithOffers() {
            return (this.displayedInternetOffersTiles?.length || 0) > 1 && this.showDiscountedInternetOfferTile;
        },
        showDiscountedOfferTileWithAlternativeOffers() {
            return (this.displayedInternetOffersTiles?.length || 0) === 1 && this.showDiscountedInternetOfferTile;
        },
    },
    mounted() {
        this.addEventListerOnMenuFibreAdsl();
        this.selectInternetOffersTilesList();
        if (this.dto.showAllOffers) {
            this.sliceMoreOffersSegments();
        }
        this.alignDivs(listOfDivToAlign);
        this.addElementsForModalToggle();
        this.addEventListerOnLiveboxPopinMenu();
        window.addEventListener("resize", this.resizeDivToAlign);
        window.addEventListener("hashchange", this.selectInternetOffersTilesList);
        this.$refs.offersRef.classList.remove('not-mounted');
    },
    updated() {
        this.alignDivs(listOfDivToAlign);
        this.addElementsForModalToggle();
    },
    methods: {
        readHash() {
            const hash = window.location.hash;
            return hash.startsWith("#") ? hash.substring(1) : hash
        },
        getElementByXpath(path) {
            return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
        },
        addElementsForModalToggle() {
            document.querySelectorAll(".offer-edito-content").forEach(
                function (edito) {
                    const {oeventCategory, oeventLabel} = edito.dataset;

                    edito.querySelectorAll("a").forEach(
                        function (link) {
                            link.classList.add("fw-bold");
                            const hrefAttr = link.getAttribute("href");
                            if (hrefAttr.startsWith("#")) {
                                link.target = "_self";
                                link.dataset.bsToggle = "modal";
                                link.dataset.oeventCategory = oeventCategory;
                                link.dataset.oeventLabel = oeventLabel;
                                link.dataset.oeventAction = hrefAttr.substr(1);
                            } else {
                                link.target = "_blank";
                            }
                        }
                    );
                }
            );
        },
        addEventListerOnLiveboxPopinMenu() {
            document.querySelectorAll(".livebox-multi-tab1").forEach(
                function (element) {
                    element.addEventListener("click", function () {
                        document.getElementById('tab1').classList.remove('d-none');
                        document.getElementById('tab2').classList.add('d-none')
                    }, false)
                }
            );
            document.querySelectorAll(".livebox-multi-tab2").forEach(
                function (element) {
                    element.addEventListener("click", function () {
                        document.getElementById('tab2').classList.remove('d-none');
                        document.getElementById('tab1').classList.add('d-none');
                    }, false)
                }
            );
        },
        addEventListerOnMenuFibreAdsl() {
            document.querySelectorAll(".menu-fibre-adsl").forEach(
                function (element) {
                    element.addEventListener("click", function () {
                        window.location.href = element.href
                    }, false)
                }
            );
        },
        toggleAttributes() {
            this.showAttributes = !this.showAttributes;
            if (this.showAttributes) {
                this.toggleAttributesBtnLabel = this.hideAttributesBtnLabel
                this.toggleAttributesBtnTms = this.hideAttributesBtnTms
                setTimeout(() => {
                    this.resizeCollapsibleDivToAlign()
                }, 100);
                window.addEventListener("resize", this.resizeCollapsibleDivToAlign)
            } else {
                this.toggleAttributesBtnLabel = this.showAttributesBtnLabel
                this.toggleAttributesBtnTms = this.showAttributesBtnTms
                window.removeEventListener("resize", this.resizeCollapsibleDivToAlign)
            }
        },
        resetToggleAttributes() {
            this.showAttributes = false;
            this.toggleAttributesBtnLabel = this.showAttributesBtnLabel
            this.toggleAttributesBtnTms = this.showAttributesBtnTms
            window.removeEventListener("resize", this.resizeCollapsibleDivToAlign)
        },
        resizeDivToAlign() {
            this.alignDivs(listOfDivToAlign);
        },
        resizeCollapsibleDivToAlign() {
            this.alignDivs(listOfCollapsibleDivToAlign);
        },
        alignDivs(divsToAlign) {
            if (this.dto && this.dto.alignOnlySameLineDivsHeights) {
                alignDivsHeightsByLine(divsToAlign);
            } else {
                alignDivHeights(divsToAlign);
            }
        },
        selectInternetOffersTilesList() {
            if (this.dto?.tabs) {
                if (this.readHash() === this.dto.tabs.rightTab.id) {
                    this.toggleTab({tab: this.dto.tabs.rightTab.id});
                }
                else {
                    this.toggleTab({tab: this.dto.tabs.leftTab.id});
                }
            } else {
                this.offersOffset = 0;
                this.selectedInternetOffersTiles = this.internetBasicsOffersTiles;
                this.displayedOffersAnimation = this.offersAnimation;
                this.displayedInternetMobileAtHomeOffersTiles = this.internetMobileAtHomeOffersTiles;
                this.sliceMoreOffersSegments();
            }
        },
        toggleTab(selectedTab) {
            if (!this.dto.showAllOffers) {
                this.offersOffset = 0;
            }
            if (selectedTab.tab === this.dto?.tabs?.rightTab?.id) {
                this.selectedInternetOffersTiles = this.internetSmartTVOffersTiles;
                this.displayedOffersAnimation = this.rightTabOffersAnimation;
                this.displayedInternetMobileAtHomeOffersTiles = [];
                this.displayedAlternativeOffersTiles = [];
            } else {
                this.selectedInternetOffersTiles = this.internetBasicsOffersTiles;
                this.displayedOffersAnimation = this.leftTabOffersAnimation;
                this.displayedInternetMobileAtHomeOffersTiles = this.internetMobileAtHomeOffersTiles;
                this.displayedAlternativeOffersTiles = this.alternativeOffersTiles;
            }
            this.sliceMoreOffersSegments();
        },
        sliceMoreOffersSegments() {
            if (this.offersOffset < this.selectedInternetOffersTiles.length) {
                if (this.offersOffset === 0 && this.selectedInternetOffersTiles.length > 3) {
                    this.offersOffset = 3;
                } else {
                    this.offersOffset = this.selectedInternetOffersTiles.length;
                }
            }
            this.displayedInternetOffersTiles = this.selectedInternetOffersTiles.slice(0, this.offersOffset);
            return this.displayedInternetOffersTiles;
        },
        sliceLessOffersSegments() {
            if (this.offersOffset < 0) {
                return
            }
            this.displayedInternetOffersTiles = this.selectedInternetOffersTiles.slice(0, 3);
            this.offersOffset = 3;
            return this.displayedInternetOffersTiles;
        },
    }
});
